<template>
    <v-row class="py-3">
      <v-col class="d-flex align-center" cols="12" md="6">
        <v-card-subtitle class="title px-0">{{ $t('mainStore.aboutStore.storeName') }}</v-card-subtitle>
      </v-col>
      <v-col class="d-flex align-center justify-end" cols="12" md="6">
        <div class="d-flex align-center">
          <template v-if="readOnly">
            <div class="pt-5 pb-6 pr-3">{{ storeName }}</div>
            <v-btn icon @click="enableEditMode">
              <v-icon>mdi-pencil-outline</v-icon>
            </v-btn>
          </template>
          <template v-else>
            <v-text-field ref="textArea" v-model="storeNameInput" @keyup.enter="saveChanges" @keyup.esc="cancelChanges"></v-text-field>
            <v-btn icon color="success" @click="saveChanges">
              <v-icon>mdi-check-circle-outline</v-icon>
            </v-btn>
            <v-btn icon color="info" @click="cancelChanges">
              <v-icon>mdi-restart</v-icon>
            </v-btn>
          </template>
        </div>
      </v-col>
    </v-row>
  </template>
  
  <script>
  export default {
    name: 'storeNameVue',
    props: {
      storeName: {
        type: String,
        required: true
      },

   
    },
    data() {
      return {
        readOnly: true,
        storeNameInput: this.storeName
      };
    },
    methods: {
      enableEditMode() {
        this.readOnly = false;
        this.$nextTick(() => {
          this.$refs.textArea.focus();
        });
      },
      saveChanges() {
        this.readOnly = true;
        this.$emit('update:storeName', this.storeNameInput);
      },
      cancelChanges() {
        this.storeNameInput = this.storeName;
        this.readOnly = true;
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  
  </style>
  